import Navbar from './navbar';
import NavbarHeader from './navbar/navbar-header';

const Header = () => {
    return (
        <header>
            <Navbar>
                <NavbarHeader />
            </Navbar>
        </header>
    );
};

export default Header;
